import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRelatedRailyTaxi from "./billings-order-related-raily-taxi";
import BillingsOrderRelatedRailyTaxiParams from "./billings-order-related-raily-taxi-params";

const useBillingsOrderRelatedRailyTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRelatedRailyTaxi[]>([]);

  const load = async (
    params: BillingsOrderRelatedRailyTaxiParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderRelatedRailyTaxiBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRelatedRailyTaxi;
